// frontend/src/services/PositionService.js
import axios from 'axios';

class PositionService {
  associateSkill(sessionId, positionId, skillId) {
    return axios.post(
      `${process.env.REACT_APP_API_URL}/sessions/${sessionId}/positions/${positionId}/skills/${skillId}`
    );
  }

  removeSkill(sessionId, positionId, skillId) {
    return axios.delete(
      `${process.env.REACT_APP_API_URL}/sessions/${sessionId}/positions/${positionId}/skills/${skillId}`
    );
  }
}

export default new PositionService();
